import m from "mithril";
import { AuthLoginResponse } from "~/types";

export const checkMFAValidation = (): Promise<AuthLoginResponse|null> => {
  return m.request({
    method: "GET",
    url: "/auth/mfa/validation"
  });
};
